import { deleteData, getData, postData, patchData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { AxiosRequestConfig } from "axios";
import { formatDate } from "src/utils/string/stringUtil";
import { ResponseDto } from "src/dtos/common/responseDto";

import { SYS3050_R01Dto } from "./Dto_SYS3050_R01";
import { SYS3050_R01Filter } from "./Store_SYS3050_R01";

const baseUrl = `${config.apiUrl}/SYS3050_R01`;

// 메뉴 리스트 조회 (검색 조건 포함)
export const getSYS3050_R01List = async (option: string, params: Partial<SYS3050_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;
	const requestParams = {
		compCd: params.compCd || undefined,
		orgCd: params.orgCd || undefined,
		empSts: params.empSts || undefined,
		date: params.date ? formatDate(params.date) : undefined,
		listLength,
	}

	return await getData<ResponseDto<SYS3050_R01Dto[]>>(url, { params: requestParams });
}

export const getSYS3050_R01AllCount = async (params: Partial<SYS3050_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, {
		params: {
			...params
		}
	});
}

export const getSYS3050_R01One = async (empNo: string) => {
	const url = `${baseUrl}/one/${empNo}`;
	
	return await getData<ResponseDto<SYS3050_R01Dto>>(url);
}

// 신규 등록
export const createSYS3050_R01 = async (data: SYS3050_R01Dto) => {
	const url = `${baseUrl}`;  // ✅ 경로 수정
	return await postData<SYS3050_R01Dto, ResponseDto<SYS3050_R01Dto[]>>(url, data);
}

// 수정 (무조건 배열 받음)
export const patchSYS3050_R01 = async (data: SYS3050_R01Dto[]) => {
	const url = `${baseUrl}`;  // ✅ 경로 수정
	return await patchData<SYS3050_R01Dto[], ResponseDto<SYS3050_R01Dto[]>>(url, data);
}

// 삭제
export const deleteSYS3050_R01 = async (empNo: string) => {
	return await deleteData<ResponseDto<any>>(baseUrl, { params: { empNo } });
}

//엑셀다운로드드
export const downloadExcel_SYS3050_R01 = async (option: string, params: Partial<SYS3050_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/excel/${option}`;

	const requestParams = {
		compCd: params.compCd || undefined,
		orgCd: params.orgCd || undefined,
		empSts: params.empSts || undefined,
		date: params.date ? formatDate(params.date) : undefined,
		listLength,
	}
  
	return await getData<ResponseDto<string>>(url, {
	  params: requestParams
	})
  }